import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const AdminSidebar = () => {
  const navItems = [
    { path: '/admin/dashboard', name: '🏠 Dashboard', icon: '🏠' },
    { 
      section: '📝 Content Management',
      items: [
        { path: '/admin/adventures', name: '🤿 Adventures Management', icon: '🤿' },
        { path: '/admin/calendar', name: '📅 Calendar & Availability', icon: '🗓️' },
        { path: '/admin/reviews', name: '⭐ Reviews & Testimonials', icon: '⭐' },
        { path: '/admin/gallery', name: '🖼️ Gallery Management', icon: '🖼️' },
        { path: '/admin/campaigns', name: '📣 Media Campaigns', icon: '📣' },
        { path: '/admin/video-studio', name: '🎬 Auto Video Studio', icon: '🎬' },
        { path: '/admin/footage-preprocessor', name: '🎞️ Footage Preprocessor', icon: '🎞️' },
        { path: '/admin/faqs', name: '❓ FAQ Management', icon: '❓' },
      ]
    },
    { 
      section: '💼 Business Operations',
      items: [
        { path: '/admin/bookings', name: '📅 Bookings', icon: '📅' },
        { path: '/admin/customer-details', name: '👤 Customer Details', icon: '👤' },
        { path: '/admin/contacts', name: '💬 Contact Messages', icon: '💬' },
        { path: '/admin/api-settings', name: '🔌 API Settings', icon: '🔌' },
        { path: '/admin/settings', name: '⚙️ Site Settings', icon: '⚙️' },
      ]
    },
  ];

  return (
    <div className="w-64 bg-gray-900 text-white min-h-screen">
      <div className="p-6 border-b border-gray-800">
        <h1 className="text-xl font-bold">Admin Panel</h1>
        <p className="text-gray-400 text-sm">Dive Camp Adventures</p>
      </div>

      <nav className="mt-6">
        {navItems.map((section, sectionIndex) => {
          if (section.path) {
            // Dashboard item (no section)
            return (
              <motion.div
                key={section.path}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: sectionIndex * 0.1 }}
              >
                <NavLink
                  to={section.path}
                  className={({ isActive }) =>
                    `flex items-center px-6 py-3 text-sm transition-colors ${
                      isActive
                        ? 'bg-blue-600 text-white border-r-4 border-blue-400'
                        : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                    }`
                  }
                >
                  <span className="mr-3 text-lg">{section.icon}</span>
                  {section.name}
                </NavLink>
              </motion.div>
            );
          }
          
          // Section with items
          return (
            <motion.div
              key={section.section}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: sectionIndex * 0.1 }}
              className="mt-8"
            >
              <div className="px-6 py-2">
                <h3 className="text-xs uppercase tracking-wider text-gray-500 font-semibold">
                  {section.section}
                </h3>
              </div>
              {section.items.map((item, itemIndex) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center px-6 py-3 text-sm transition-colors ${
                      isActive
                        ? 'bg-blue-600 text-white border-r-4 border-blue-400'
                        : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                    }`
                  }
                >
                  <span className="mr-3 text-lg">{item.icon}</span>
                  {item.name}
                </NavLink>
              ))}
            </motion.div>
          );
        })}
      </nav>

      <div className="absolute bottom-6 left-6">
        <a
          href="/"
          className="flex items-center text-gray-400 hover:text-white text-sm transition-colors"
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to Site
        </a>
      </div>
    </div>
  );
};

export default AdminSidebar;